<template lang="pug">
  v-layout(row justify-center)
    v-flex(xs12)
      v-card-title.pb-0
        h3 АИС "Дети в ТЖС"
      v-card-text
        v-container
          v-layout(justify-center wrap)
            v-card(
              class="card-item",
              v-for="el in dbLinks",
              :key="el.title",
              @click.prevent="openDialog(el.id, el.title)")
              v-layout(justify-center)
                div.icon-box
                  img(:src="el.icon")
              v-card-text(class="text-xs-center pb-0")
                p(class="card-title") {{ el.title }}
            v-card(
              class="card-item",
              v-for="el in routerLinks",
              :key="el.title",
              @click="openPage(el.link)")
              v-layout(justify-center)
                div.icon-box
                  img(:src="el.icon")
              v-card-text(class="text-xs-center pb-0")
                p(class="card-title") {{ el.title }}
    DataBaseView(
      :isShow="isDialog",
      :id="dbId",
      :name="dbName",
      @close-dialog="close")
    Preloader(v-if="isPreloader")
</template>

<script>
import DataBaseView from '../DataBase/DataBaseView'
import Preloader from '../Common/Preloader/Preloader'
export default {
  name: 'Catalog',
  components: { Preloader, DataBaseView },
  data: () => ({
    isDialog: false,
    dbId: '',
    dbName: '',
    isPreloader: false,
    dbLinks: [
      {
        title: 'Сигнал',
        icon: '/static/icons/notification.svg',
        id: '274f0c5d-2c02-43b2-8d59-77e73b4494ea'
      },
      {
        title: 'Выявление',
        icon: '/static/icons/loupe.svg',
        id: '090ec34d-30be-4484-9970-78cc9545f185'
      },
      {
        title: 'Дети',
        icon: '/static/icons/children.svg',
        id: '918bc9db-a779-415f-8b4e-47b978228b17'
      },
      { title: 'ИПЗР', icon: '/static/icons/ipzr.svg', id: '7a868f4a-cded-49bf-8be2-1e0461423ebe' },
      {
        title: 'Дети в ТЖС',
        icon: '/static/icons/sad-baby.svg',
        id: '9d7c9150-265f-42bc-b2ce-bb706d7408fc'
      }
    ],
    routerLinks: [
      { title: 'Задачи', icon: '/static/icons/checklist.svg', link: '/main/issue' },
      { title: 'Отчетность', icon: '/static/icons/folder.svg', link: '/main/reports' }
    ]
  }),
  methods: {
    openPage(link) {
      this.$router.push({ path: `${link}` })
    },
    openDialog(id, name) {
      this.$store.commit('SET_ID_FOR_EXCEL_UPLOAD', id)
      this.isPreloader = true
      this.$store.dispatch('GET_DB_RECORDS_LIST', { id: id }).then(() => {
        this.dbName = name
        this.dbId = id
        this.isDialog = true
        this.isPreloader = false
      })
    },
    close(value) {
      this.isDialog = value
      this.dbName = ''
      this.dbId = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__title {
  padding-top: 80px;
}
.card-item {
  width: 165px;
  border: 1px solid #d1d1d6 !important;
  border-radius: 3px;
  padding-top: 20px;
  margin: 20px;
  box-shadow: none;
  .icon-box {
    width: 80px;
    height: 80px;
    background: #c7c7cc;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
  }
  .card-title {
    font-size: 1.5rem;
    font-weight: 500;
  }
}
.card-item:hover {
  border: 1px solid #007aff;
  background: #f0f7ff;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);
  .icon-box {
    background: #007aff;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
}
@media screen and (max-width: 1264px) {
  .card-item {
    margin: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/Catalog.vue